import { render, staticRenderFns } from "./VotingsMandateVote.vue?vue&type=template&id=392dc7a8&"
import script from "./VotingsMandateVote.vue?vue&type=script&lang=js&"
export * from "./VotingsMandateVote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports